// register component(s) with react habitat
// <div data-component="FeaturedNewsSlider"></div>

export default {
  FeaturedNewsSlider: () =>
    import(
      /* webpackChunkName: "featured-news-slider" */
      './index'
    ),
}
